import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect, useSelector} from 'react-redux';
import {compose} from 'redux';
import classNames from 'classnames';
import {Button} from '@spothero/ui';
import SpotListItemBase from 'common/spot-card-base/v2';
import FacilitySummary from 'common/facility-summary/v2';
import {routeToSpotDetails} from 'router/router-utils';
import {push} from 'store/router/router-actions';
import {PROPTYPE_EVENT_PACKAGE_FACILITY_SUMMARY} from '@/proptypes/index';
import {setSpotDetailReferrer} from 'store/spot/spot-actions';
import {FACILITY_SUMMARY_VIEW_TYPES} from 'common/facility-summary/utils';
import {useLabel} from 'hooks/spot/price/use-label';

export const SpotListItemEventPackage = ({
    spot,
    isActive,
    isAdmin,
    isRebookingReservation,
    history,
    pushTo,
    setSpotDetailReferrerTo,
    onShowDetailsClick,
}) => {
    const {highlightedSpotId} = useSelector(state => state.spots);
    const {spotId, availability, selectedRate} = spot;
    const label = useLabel({});
    const isHighlighted = `${highlightedSpotId}` === `${spotId}`;
    const containerClasses = classNames(
        {'SpotListItem-active': isActive},
        {'SpotListItem-hovered': isHighlighted},
        {unavailable: !availability.available}
    );
    const bookItClasses = classNames('SpotListItem-book-it', {
        'admin-border-button': isAdmin && isRebookingReservation,
    });

    const onSpotItemClick = evt => {
        evt.preventDefault();

        onShowDetailsClick(spot.spotId);

        const {location} = history;

        setSpotDetailReferrerTo('list');
        routeToSpotDetails({
            method: pushTo,
            location,
            spotId,
            historyState: {referrer: 'list'},
        });
    };

    const renderCTAs = () => {
        return !availability.available && isAdmin ? (
            <Button variant="primary" isDisabled>
                Unavailable <sup className="text-light">*</sup>
            </Button>
        ) : (
            <>
                <Button
                    as={'a'}
                    href={selectedRate.expressCheckoutUrl}
                    variant="tertiary"
                    fontSize="sm"
                    className="show-details hide-on-mobile"
                >
                    Details
                </Button>
                <Button
                    as={'a'}
                    variant="primary"
                    fontSize="sm"
                    className={bookItClasses}
                    href={selectedRate.expressCheckoutUrl}
                >
                    {isRebookingReservation ? 'Rebook It' : 'Book Now'}
                </Button>
            </>
        );
    };

    return (
        <SpotListItemBase
            spotId={spotId}
            additionalClasses={containerClasses}
            onClick={onSpotItemClick}
            MainContent={
                <FacilitySummary
                    spot={spot}
                    priceLabel={label}
                    isAdmin={false}
                    view={FACILITY_SUMMARY_VIEW_TYPES.SPOT_LIST}
                    CTAs={renderCTAs()}
                />
            }
        />
    );
};

SpotListItemEventPackage.propTypes = {
    onShowDetailsClick: PropTypes.func.isRequired,
    spot: PROPTYPE_EVENT_PACKAGE_FACILITY_SUMMARY,
    isActive: PropTypes.bool,
    isAdmin: PropTypes.bool,
    isRebookingReservation: PropTypes.bool,
    history: PropTypes.shape({
        location: PropTypes.object,
    }),
    pushTo: PropTypes.func,
    setSpotDetailReferrerTo: PropTypes.func,
};

const mapDispatchToProps = {
    pushTo: push,
    setSpotDetailReferrerTo: setSpotDetailReferrer,
};

const enhance = compose(withRouter, connect(null, mapDispatchToProps));

export default enhance(SpotListItemEventPackage);
